var _rect, _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeetingImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-128 -732C-128 -733.105 -127.105 -734 -126 -734H4666C4667.1 -734 4668 -733.105 4668 -732V1132C4668 1133.1 4667.1 1134 4666 1134H-126C-127.105 1134 -128 1133.1 -128 1132V-732Z",
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_70)",
    filter: "url(#filter0_d_224_70)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 1668,
    transform: "translate(-28 -634)",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_224_70)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -11.5,
    y: -11.5,
    width: 342,
    height: 119,
    rx: 15.5,
    fill: "white",
    stroke: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 8,
    fill: "#84BDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8619 52.7224C30.0994 52.7224 32.7238 50.0982 32.7238 46.8612C32.7238 43.6241 30.0994 41 26.8619 41C23.6245 41 21 43.6241 21 46.8612C21 50.0982 23.6245 52.7224 26.8619 52.7224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1634 52.7224C72.4009 52.7224 75.0253 50.0982 75.0253 46.8612C75.0253 43.6241 72.4009 41 69.1634 41C65.926 41 63.3015 43.6241 63.3015 46.8612C63.3015 50.0982 65.926 52.7224 69.1634 52.7224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9253 54.0346C43.7039 54.0346 40.7511 51.8476 40.7511 48.6983C40.7511 47.4954 41.7354 46.5113 42.9384 46.5113C44.1414 46.5113 45.1256 47.4954 45.1256 48.6983C45.1256 49.0264 46.2193 49.6606 47.9253 49.6606C49.6314 49.6606 50.725 49.0264 50.725 48.6983C50.725 47.4954 51.7093 46.5113 52.9123 46.5113C54.1153 46.5113 55.0996 47.4954 55.0996 48.6983C55.0996 51.8257 52.1468 54.0346 47.9253 54.0346Z",
    fill: "white"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-126 -733H4666V-735H-126V-733ZM4667 -732V1132H4669V-732H4667ZM4666 1133H-126V1135H4666V1133ZM-127 1132V-732H-129V1132H-127ZM-126 1133C-126.552 1133 -127 1132.55 -127 1132H-129C-129 1133.66 -127.657 1135 -126 1135V1133ZM4667 1132C4667 1132.55 4666.55 1133 4666 1133V1135C4667.66 1135 4669 1133.66 4669 1132H4667ZM4666 -733C4666.55 -733 4667 -732.552 4667 -732H4669C4669 -733.657 4667.66 -735 4666 -735V-733ZM-126 -735C-127.657 -735 -129 -733.657 -129 -732H-127C-127 -732.552 -126.552 -733 -126 -733V-735Z",
    fill: "#222222",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_224_70",
    x: -44,
    y: -646,
    width: 407,
    height: 1700,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_224_70"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_224_70",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_224_70",
    x: -28,
    y: -24,
    width: 375,
    height: 152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_224_70"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_224_70",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 1668,
    fill: "white",
    transform: "translate(-28 -634)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingImg);
export default __webpack_public_path__ + "static/media/meeting_img.b6766338bf027eaa24a6d9537d2a1650.svg";
export { ForwardRef as ReactComponent };